import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core'

@Component({
    selector: 'lib-ahoyrtc-video-widget-add',
    imports: [
        TranslatePipe
    ],
    templateUrl: './ahoyrtc-video-widget-add.component.html',
    styleUrl: './ahoyrtc-video-widget-add.component.scss'
})
export class AhoyrtcVideoWidgetAddComponent {

}
